import React from "react";

import { GroupHeader, GroupHeaderContent, GroupHeaderHint, GroupHeaderTitle } from "./ErrorGroupHeader.styles";

export interface ErrorGroupHeaderProps {
    title: string | null;
    hint?: string;
    tid?: string;
    fixed?: boolean;
    noWrap?: boolean;
}

export const ErrorGroupHeader = ({ fixed, tid, title, hint, noWrap }: ErrorGroupHeaderProps) => (
    <GroupHeader>
        <GroupHeaderContent fixed={fixed ?? false}>
            <GroupHeaderTitle data-tid={tid} noWrap={noWrap}>
                {title}
            </GroupHeaderTitle>
            {hint && <GroupHeaderHint>{hint}</GroupHeaderHint>}
        </GroupHeaderContent>
    </GroupHeader>
);
